import React, { useEffect , useState } from 'react';

//*MUI
import { Box, Card, Divider } from '@mui/material';
import { makeStyles } from "@mui/styles";

//*files
import logo from '../Assets/Images/SideMenu/vjLogo.jpg';
import justImage from "../Assets/Images/Login/JustImage.svg";
import barcodeImage from "../Assets/Images/Login/barcodeimg.svg";
import axios from 'axios';
import Button from '../Subcomponents/Button';
import AddAgreementConfirmation from '../Modals/AddAgreementConfirmation/AddAgreementConfirmation';


const useStyles = makeStyles((theme) => ({
  FirstLabel: {
    fontSize: "1.1rem",
    lineHeight: "1.8rem",
    fontFamily: "Inter-Medium",
    color: "#98A2B3",
    marginBottom: "1rem",
    width: "100px",
  },
  SecondLabel: {
    fontSize: "1.3rem",
    lineHeight: "2.2rem",
    fontFamily: "Inter-Regular",
    color: "#000000",
    padding: "0 1rem",
    width: "250px",
  },
  RowDiv: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
  },
  ThirdLabel: {
    fontSize: "1.3rem",
    lineHeight: "2.2rem",
    fontFamily: "Inter-SemiBold",
    color: "#000000",
    padding: "0 1rem",
    width: "250px",
  },
}))


function TokenCard() {
  const classes = useStyles();

  useEffect(() => {
    let body = {
      "number": "+919420102285",
      "message": "Hello Vedashree.\nYou have successfully registered with us and here are your login credentials.\nUser ID : CPID000000\nPassword : Vedashree@123\npartners.vjerp.com\nRegards,\nVilas Javdekar Developers",
      "is_international_number": false
    }
    axios.post(`${process.env.REACT_APP_PAYMENT_LINK_URL}message/sendMessage`, body).then((resp) => {
      console.log(resp)
    }).catch((err) => {
      console.log(err)
    })
  }, [])

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = (event, reason) => {
    if (reason && reason === 'backdropClick') return;
    setOpen(false);
  };

  return (
    <Box margin={"auto"} width={'380px'}>
      <Card variant="outlined" display={'flex'} flexDirection={"column"} justifyContent={'center'} alignItems={'center'}
        sx={{
          borderRadius: 2,
          p: 2,
          minWidth: 300,
        }}>
        <Box p={2} display={"flex"} justifyContent={"center"} alignItems={"center"}>
          <img src={logo} alt="VJ-Logo" style={{ width: '20rem' }} />
        </Box>
        <Box p={2} display={"flex"} justifyContent={"center"}>
          <img src={justImage} alt="Event-Image" style={{ width: '300px' }} />
        </Box>

        <Divider />

        <Box margin={"2rem 1rem"}>
          <Box className={classes.RowDiv}>
            <Box className={classes.FirstLabel} >Token Name :</Box>
            <Box className={classes.ThirdLabel}>Y1Et-Jmlp-23</Box>
          </Box>
          <Box className={classes.RowDiv}>
            <Box className={classes.FirstLabel}>Event Name :</Box>
            <Box className={classes.ThirdLabel}>Maa Laxmi Properties | 3 BHK </Box>
          </Box>
          <Box className={classes.RowDiv}>
            <Box className={classes.FirstLabel}>Date :</Box>
            <Box className={classes.SecondLabel}>Friday March 24 2023, 04: 50 PM</Box>
          </Box>
        </Box>

        <Divider />

        <Box margin={"2rem 1rem"}>
          <Box className={classes.RowDiv}>
            <Box className={classes.FirstLabel} >Token Amount :</Box>
            <Box className={classes.SecondLabel}> <span className={classes.ThirdLabel}>₹</span>50.000</Box>
          </Box>
          <Box className={classes.RowDiv}>
            <Box className={classes.FirstLabel}>Date :</Box>
            <Box className={classes.SecondLabel}>Friday March 24 2023, 04: 50 PM</Box>
          </Box>
        </Box>


        <Divider />

        <Box className={classes.RowDiv} margin={"2rem 1rem"}>
          <Box>
            <img src={barcodeImage} alt="Token-Barcode" style={{ width: '9rem' }} />
          </Box>

          <Box ml={6} mt={2}>
            <Box className={classes.ThirdLabel} padding={"0 !important"}>Global Token</Box>
            <Box className={classes.ThirdLabel} padding={"0 !Important"}>Gt-202303 24-8790</Box>
          </Box>


          
        </Box>
      </Card>
      <Box>
      <Button
            style={{
              color: "#fff",
              backgroundColor: "#1570EF",
              fontSize: "1.4rem",
              lineHeight: "2rem",
              fontFamily: "Roboto-Regular",
            }}
            padding={'0.8rem 2.6rem'}
            btnName={'Add Agreement Confirmation'}
            clicked={handleOpen}
          />
      </Box>
      {open && (
        <AddAgreementConfirmation
          open={open}
          handleClose={handleClose}
          
        />)}
    </Box>
  )
}

export default TokenCard